import styled from 'styled-components';
import { InterestedBoxStyled } from '../InterestedBoxStyled';
import { rem } from 'polished';

export const InterestedBoxStyledOV = styled(InterestedBoxStyled)`
    .links-section {
        .section {
            background: ${({ theme }) => theme.colors.grey10};
            border-radius: 0;

            .phone {
                font-size: ${rem(22)};
                color: ${({ theme }) => theme.colors.black2};
                text-decoration: unset;
            }

            .description2 {
                color: ${({ theme }) => theme.colors.grey28};
            }

            button {
                font-weight: ${({ theme }) => theme.fontWeights.textRegular};
                background: ${({ theme }) => theme.colors.grey10};

                &:hover,
                &:focus-visible {
                    background: ${({ theme }) => theme.colors.black2};
                    color: ${({ theme }) => theme.colors.pureWhite};
                }
            }
        }
    }

    .dealerShare {
        &:hover,
        &:focus-visible {
            border-bottom: 1px solid ${({ theme }) => theme.colors.black2};
        }
    }

    .reinsurance {
        color: ${({ theme }) => theme.colors.black};
        line-height: 1.29;
        font-size: ${rem('14px')};
        border-bottom: 1px solid ${({ theme }) => theme.colors.black};
    }
`;
